import {useDebugValue} from 'react';

import {getNoUndefValuesObject} from '../../../utils/object';

function useTranslations(defaultTranslations, ...otherTranslations) {
    const specifiedTranslations = otherTranslations.reduce((accumulatedTranslations, currentTranslations) => ({
        ...accumulatedTranslations,
        ...getNoUndefValuesObject(currentTranslations)
    }), {});

    const translations = {
        ...defaultTranslations,
        ...specifiedTranslations
    };

    const result = {
        translations
    };

    useDebugValue(result);

    return result;
}

export {useTranslations};
